import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { hashToCollection, QuestionForm, } from '../../../Shared/index';
import * as questionActions from '../../actions/questions';
import { Match } from '../../interfaces/match';
import { Question } from '../../interfaces/questions';
import { ConceptReducerState } from '../../reducers/conceptsReducer';
import { QuestionsReducerState } from '../../reducers/questionsReducer';

interface ConceptProps {
  concepts: ConceptReducerState;
  match: Match;
  questions: QuestionsReducerState;
  dispatch: Function;
}

class Concept extends React.Component<ConceptProps> {
  constructor(props: ConceptProps) {
    super(props)

    this.submit = this.submit.bind(this)
  }

  getConcept() {
    const {data} = this.props.concepts, {conceptID} = this.props.match.params;
    return data[0].find(c => c.uid === conceptID)
  }

  questionsForConcept() {
    const questionsCollection = hashToCollection(this.props.questions.data)
    return questionsCollection.filter(q => q.concept_uid === this.props.match.params.conceptID && q.flag !== 'archived')
  }

  renderQuestionsForConcept() {
    const questionsForConcept = this.questionsForConcept()
    const listItems = questionsForConcept.map((question: Question) => {
      const archivedTag = question.flag === 'archived' ? <strong>ARCHIVED - </strong> : ''
      return (
        <li key={question.key}>
          <Link to={'/admin/questions/' + question.key + '/responses'}>
            <span dangerouslySetInnerHTML={{ __html: question.prompt }} />
          </Link>
        </li>
      );
    })
    return (
      <ul>{listItems}</ul>
    )
  }

  submit = (question): void => {
    this.props.dispatch(questionActions.submitNewQuestion(question))
  }

  render() {
    const {conceptID} = this.props.match.params;

    if (this.props.concepts.hasreceiveddata && this.getConcept()) {
      return (
        <div>
          <Link to="/admin/concepts">Return to All Concepts</Link>
          <h4 className="title">{this.getConcept().displayName}</h4>
          <h6 className="subtitle">{this.questionsForConcept().length} Questions</h6>
          <QuestionForm concepts={this.props.concepts} defaultConceptUID={conceptID} isGrammarQuestion={true} isNew={true} question={{}} submit={this.submit} />
          {this.renderQuestionsForConcept()}
        </div>
      )
    } else {
      return (<div>Loading...</div>)
    }
  }
}

function select(state: any) {
  return {
    concepts: state.concepts,
    questions: state.questions
  }
}

function mergeProps(stateProps: Object, dispatchProps: Object, ownProps: Object) {
  return {...ownProps, ...stateProps, ...dispatchProps}
}

export default connect(select, dispatch => ({dispatch}), mergeProps)(Concept)
